import type { GetPlanCancellationsResponse } from '@/types/plan'
import type { Options } from 'ky'
import { httpClient } from '@/utils/http'

export const planService = {
  cancellations: (options?: Options) =>
    httpClient
      .get('plan_cancellations', options)
      .json<GetPlanCancellationsResponse>(),
}
